// UI
import SidebarSettings from './SidebarSettings'

export default SidebarSettings